<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
    
      <v-flex xs12>
        <v-card flat tile class="elevation-2">
            <v-card v-if="giftCardsListError" key="giftCardsListErrorYes" class="pa-3">
              {{ giftCardsListErrorMessage }}
            </v-card>
            <v-card-title class="py-3 px-4">
                <v-layout row wrap>
                    <v-flex sm12 md4 lg4 left>
                       <v-subheader> All Gift Cards</v-subheader>
                    </v-flex>
                    <v-flex sm12 md4 lg4>
                        <v-text-field
                        @input="filterByName"
                        append-icon="search"
                        label="Search"
                        single-line
                        hide-details
                      ></v-text-field>
                    </v-flex>
                     <v-flex sm12 md4 lg4>
                        <v-select :items="userList"
                        v-model="filters.user_id"
                        label="Search by User"
                        @change="filterByUser"
                        item-value="value">
                      </v-select>  
                    </v-flex>
                </v-layout>
          </v-card-title>

          <v-data-table
            v-if="$vuetify.breakpoint.smAndUp"
            :headers="headers"
            :items="allGiftCards"
            :search="filters"
            :custom-filter="customFilter"
            class="pa-3 tabulardata"
          >
            <template slot="items" slot-scope="props">
              <td class="text-xs-left" width="250">
                <router-link :to="{ name: 'GiftCardsTransactions', params:{ giftcard_code:props.item.gift_card_number } }">
                  {{ props.item.gift_card_number }}
                </router-link>
              </td>
              <td class="text-xs-left">{{ props.item.user_full_name }}</td>
              <td class="text-xs-left">{{ props.item.pin }}</td>
              <td class="text-xs-left">{{ props.item.type }}</td>
              <td class="text-xs-left">{{ props.item.status }}</td>
              <td class="text-xs-left">{{ props.item.balance }}</td>
            </template>
            <v-alert slot="no-results" :value="true" color="error" icon="warning">
              <template v-if="filters.user_id">
                User ID "{{ filters.user_id }}" found no results.
              </template>
              <template v-else>
                Your search for "{{ search }}" found no results.
              </template>
              
            </v-alert>
          </v-data-table>
          <v-data-iterator
            v-else
            :items="allGiftCards"
            content-tag="v-layout"
            row
            wrap
            :search="search"
            class="pa-3"
          >
            <v-flex
              slot="item"
              slot-scope="props"
              xs12
              sm6
              md4
              lg3
            >
              <v-list-tile>
                <v-list-tile-content>{{ props.item.gift_card_number }}</v-list-tile-content>
              </v-list-tile>
              <v-divider></v-divider>
              <v-list dense>
                <v-list-tile>
                  <v-list-tile-content>{{ props.item.pin }}</v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>{{ props.item.type }}</v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>{{ props.item.status }}</v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>{{ props.item.balance }}</v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-flex>
          </v-data-iterator>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import axios from "axios";
import Env from "../environment";
import { mapActions, mapGetters } from 'vuex'
import AuthApi from './controllers/AuthApi';

export default {
  name: "GiftCards",
  props: {
    msg: String
  },
  data: () => ({
    search: '',
    filters: {
      name: '',
      user_id: ''
    },
    userList: [{
        text: 'Select user',
        value: ''
    }],
    giftCardsListError: false,
    giftCardsListErrorMessage: "",
    headers: [
      { text: "Number", value: "gift_card_number", },
      { text: "User Name", value: "user_full_name", },
      { text: "Pin", value: "pin", sortable: false,},
      { text: "Type", value: "type", sortable: false, },
      { text: "Status", value: "status", },
      { text: "Balance", value: "balance", },
    ],
  }),
  computed: {
    allGiftCards() {
      return this.$store.getters.getGiftCards;
    },
  },
  watch: {
    '$route.params.user_id': function(val) {
      if(!val){
        this.filterByUser('')
      }
    },
  },  
  created() {
    this.$emit("load");
    this.init();
  },
  mounted() {
    const self = this
    const userListMap = this.$store.getters.getUsers;
    userListMap.map(item => {
      self.userList.push({
        text: item.first_name + ' ' +  item.last_name,
        value: item.id
      });
    });

    if( this.$route.params.user_id ){
      this.filterByUser(this.$route.params.user_id)
    }
  },
  methods: {
    /**
     * To get occasions and store it
     * @function
     * @returns {undefined}
     */
    init() {
      AuthApi.getApi(`${Env.giftcard_url}/api/gift_card/list`)
        .then(res => {
          this.$store.dispatch("SET_GIFT_CARDS", res.data.payload.data);
        })
        .then(() => {
          this.$emit("loadEnd");
        })
        .catch(err => {
          if (err.response.data.declaration === "auth_token_needs_refresh") {
            this.$emit("expire");
          } else if (err.response.data.declaration === "invalid_business") {
            this.giftCardsListError = true;
            this.giftCardsListErrorMessage = err.response.data.payload.message;
            this.$emit("loadEnd");
          } else {
            console.log(err);
          }
        });
    },
    /**
     *  To filter the items depending on given string
     * @function
     * @returns {undefined}
     */

    filterByName(val) {
      this.filters = this.$MultiFilters.updateFilters(this.filters, {
        name: val,
      });
    },

     /**
     *  To filter the items depending on given parameters
     * @function
     * @returns {undefined}
     */

    customFilter(items, filters, filter, headers) {
      const cf = new this.$MultiFilters(items, filters, filter, headers);
      cf.registerFilter('name', (searchWord, innerItems) => {
        if (searchWord.trim() === '') return innerItems;
        return innerItems.filter((item) => { return item.name.toLowerCase().includes(searchWord.toLowerCase()); }, searchWord);
      });
      cf.registerFilter('user_id', (userid, innerItems) => {
        if (userid === '' || userid === undefined) return innerItems;
        return innerItems.filter((item) => { return item.user_id === userid; }, userid);
      });
      return cf.runFilters();
    },

    /**
     *  To filter the items by User ID
     * @function
     * @returns {undefined}
     */
    filterByUser(val) {
      this.filters = this.$MultiFilters.updateFilters(this.filters, {
        user_id: val,
      });
    },

    ...mapActions({
      snackbar: 'snackbar/snackbar'
    }),
  }
};
</script>
<style scoped>

</style>